import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { timeout: { type: Number, default: 4000 } };

  connect() {
    this.dismissTimeout = setTimeout(() => this.dismiss(), this.timeoutValue);
  }

  disconnect() {
    clearTimeout(this.dismissTimeout);
    clearTimeout(this.removeTimeout);
  }

  dismiss() {
    this.element.classList.add("opacity-0");
    this.removeTimeout = setTimeout(() => this.remove(), 300);
  }

  remove() {
    this.element.remove();
  }
}
